<template>
    <div class="d-flex flex-row flex-nowrap">
        <span class="flex-fill"></span>
        <DateComp
            :value="props.value"
            format="DATETIME"
        />
        <ButtonComp
            button-type="Secondary"
            class="btn-sm border"
            icon="fa-gun"
            :title="$tm('groups.settimefromgunstart')"
            @click="setTimeFromGunstart"
        />
    </div>
</template>
<script setup lang="ts">
import { ButtonComp, DateComp } from '@/components';
import { useDialog, useTaskLoader } from '@/composeables';
import type { GPIOReading, GroupWithCount } from '@/objects/generated';
import { useEventStore, useToastStore } from '@/stores';
import { $tm } from '@/locize';
import GPIOReadingsListModalView from '../views/GPIOReadings/GPIOReadingsListModalView.vue';
import { GPIOReadingDao } from '@/dao';
const props = defineProps<{
    /**
     * The value to display.
     */
    value: Date | null;

    row?: GroupWithCount;

    /**
     * The callback that is called when the reading is saved.
     * @param row
     */
    saveCallback?: (row: GPIOReading, groupId: number) => void;
}>();
const { eventID } = useEventStore();
const { AddLoader, LoadState } = useTaskLoader();

/**
 * This will open a dialog to select a reading to set the start time of the group.
 * The selected reading will be saved as the start time of the group.
 * You have to confirm the selection in a second dialog.
 */
const setTimeFromGunstart = () => {
    let selectedRows: { rows: GPIOReading[] } = { rows: [] };

    useDialog().SaveCancel({
        title: 'groups.settimefromgunstart',
        body: GPIOReadingsListModalView,
        saveCallback: async () => {
            if (selectedRows.rows.length === 1) {
                useDialog().SaveCancel({
                    title: 'groups.settimefromgunstartconfirm',
                    body: $tm('groups.settimefromgunstartconfirmmessage', '', true),
                    saveCallback: async () => {
                        AddLoader(async () => {
                            let row = await GPIOReadingDao.SaveGunstartGPIOReadingForGroupStart(
                                eventID,
                                props.row!.ID,
                                selectedRows.rows[0],
                            );

                            if (props.saveCallback && row) {
                                props.saveCallback(row, props.row!.ID);
                            }
                        }, 'group.saveguntime');

                        return true;
                    },
                    savestate: LoadState.value,
                    options: {
                        TextAlign: 'center',
                    },
                });
            } else {
                useToastStore().addInfo('groups.settimefromgunstartselectone');
            }
            return true;
        },
        componentProps: {
            station: 'start',
            selectedValue: selectedRows,
        },
        options: {
            Size: 'lg',
        },
    });
};
</script>
